<div class="dropdown-card user-dropdown-card">
  <div class="dropdown-user-header">
    <div class="user-avatar">
      <app-display-user-logo [user]="tenantAccount()" [size]="36"></app-display-user-logo>
      <div class="user-status-dot"></div>
    </div>
    <div class="dropdown-user-info">
      <span class="dropdown-user-name">{{ fullName() }}</span>
      <span class="dropdown-user-email">{{ email() }}</span>
    </div>
  </div>

  <div class="dropdown-separator"></div>

  <button class="dropdown-menu-item" type="button" (click)="goToAccountSettings()">
    <img src="assets/icons/menu-gear-outline.svg" alt="" class="dropdown-item-icon filter-darkgrey">
    <span>{{ 'menu.accountSettings' | translate }}</span>
  </button>
  <button class="dropdown-menu-item dropdown-item-danger" type="button" (click)="logout()">
    <img src="assets/icons/log-out.svg" alt="" class="dropdown-item-icon filter-danger">
    <span>{{ 'menu.logout' | translate }}</span>
  </button>
</div>
